import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/caret-regular-left.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/caret-solid-right.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/recommended-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/public/next-public/common/icons/verified-buyer-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/pagination.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/customer-reviews/nettieReviewSummary.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/customer-reviews/reviewHelpfulness.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/customer-reviews/reviewList.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/customer-reviews/reviewSummary.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/reviews/productSummary.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/reviews/reviewsContent.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/ec/product/[basePath]/reviews/reviewsPage.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/[basePath]/vendor-options/productDetailClientPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ec/product/productImage.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/design-system/breadcrumbs/breadcrumbs.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/design-system/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/design-system/star-rating/starRating.tsx");
